import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { Contact, ContactsApi } from 'src/app/hickory-api';
import { ContactsSelectDialogComponent } from '../contacts-select-dialog/contacts-select-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { finalize, Subject, takeUntil } from 'rxjs';


@Component({
  selector: 'app-contacts-form-field',
  templateUrl: './contacts-form-field.component.html',
  styleUrl: './contacts-form-field.component.scss',
  standalone: false
})
export class ContactsFormFieldComponent implements OnInit, OnDestroy {
  @Input() contacts: number[];
  @Output() contactsChange = new EventEmitter<Contact[]>();
  contactsLoading = false;
  selectedContacts: Contact[] = [];
  destroy$ = new Subject<void>();

  constructor(
    private readonly dialog: MatDialog,
    private readonly contactApi: ContactsApi,
    @Inject(L10N_LOCALE) public locale: L10nLocale
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.getContacts(this.contacts);
  }

  removeRecipient(index: number) {
    this.selectedContacts.splice(index, 1);
    this.contactsChange.emit(this.selectedContacts);
  }

  getContacts(contactIds: number[]) {
    
    if (!contactIds?.length) { return ; }

    this.contactsLoading = true;
    this.contactApi.findContacts({ contactIds, includeAsset: false }).pipe(
      finalize(() => this.contactsLoading = false), 
      takeUntil(this.destroy$)
    ).subscribe({
      next: (response) => {
        const contacts = response.items;
        if (!contacts?.length) {
          return;
        }
        this.mergeSelectedContacts(contacts);
      },
    });
  }

  selectContacts() {
    const dialog = this.dialog.open(ContactsSelectDialogComponent, {
      data: {
        userType: undefined,
        showUserTypeSelection: false,
        groupId: undefined,
        selected: this.contacts,
      },
      maxWidth: '1000px',
      minWidth: '400px',
      width: '75%',
      height: '80%',
      ariaLabel: 'Contact selection dialog',
    });

    dialog.afterClosed().subscribe((contacts: Contact[]) => {
      if (!contacts?.length) {
        return;
      }

      this.mergeSelectedContacts(contacts);
      this.contactsChange.emit(this.selectedContacts);
    });
  }

  mergeSelectedContacts(contacts: Contact[]) {
    const contactMap = new Map(this.selectedContacts.map(contact => [contact.id, contact]));
    contacts.forEach(contact => contactMap.set(contact.id, contact));
    this.selectedContacts = Array.from(contactMap.values());
  }

}
